var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "wrapper",
    staticClass: "wrapper toolbar py-2 px-3 d-flex align-items-center rounded search-modal",
    class: {
      active: _vm.active
    },
    on: {
      "click": function ($event) {
        return _vm.focus($event, '.wrapper');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-search mb-0",
    class: _vm.inputIconClasses
  }), _vm.type === 'checkbox' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.query,
      expression: "query"
    }],
    ref: "input",
    staticClass: "flex-fill search ml-2 mb-0 font-weight-normal text-truncate",
    class: _vm.inputClasses,
    attrs: {
      "placeholder": _vm.placeholder,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.query) ? _vm._i(_vm.query, null) > -1 : _vm.query
    },
    on: {
      "focus": function ($event) {
        _vm.active = true;
      },
      "keyup": _vm.search,
      "change": function ($event) {
        var $$a = _vm.query,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.query = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.query = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.query = $$c;
        }
      }
    }
  }) : _vm.type === 'radio' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.query,
      expression: "query"
    }],
    ref: "input",
    staticClass: "flex-fill search ml-2 mb-0 font-weight-normal text-truncate",
    class: _vm.inputClasses,
    attrs: {
      "placeholder": _vm.placeholder,
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.query, null)
    },
    on: {
      "focus": function ($event) {
        _vm.active = true;
      },
      "keyup": _vm.search,
      "change": function ($event) {
        _vm.query = null;
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.query,
      expression: "query"
    }],
    ref: "input",
    staticClass: "flex-fill search ml-2 mb-0 font-weight-normal text-truncate",
    class: _vm.inputClasses,
    attrs: {
      "placeholder": _vm.placeholder,
      "type": _vm.type
    },
    domProps: {
      "value": _vm.query
    },
    on: {
      "focus": function ($event) {
        _vm.active = true;
      },
      "keyup": _vm.search,
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.query = $event.target.value;
      }
    }
  }), _c('button', {
    staticClass: "btn small icon close-btn",
    style: {
      opacity: _vm.active ? 1 : 0
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.active
    },
    on: {
      "click": function ($event) {
        _vm.active = false;
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })]), _c('div', {
    ref: "results",
    staticClass: "card position-absolute my-3 results py-3 overflow-hidden",
    class: _vm.resultClasses,
    staticStyle: {
      "left": "0",
      "opacity": "0",
      "box-shadow": "0"
    }
  }, [_c('virtual-list', {
    ref: "vList",
    staticClass: "overflow-auto h-100",
    attrs: {
      "data-key": "uid",
      "data-sources": _vm.results,
      "data-component": _vm.itemComponent
    },
    on: {
      "selected": _vm.select
    }
  })], 1), _vm._l(_vm.results, function (item, index) {
    return _c('div', {
      key: index
    }, [_vm._t("default", null, null, {
      item,
      setActive: _vm.setActive,
      index
    })], 2);
  })], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };